// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"78":"safety-handbbok","490":"supplier-responsibility","537":"procurement-post","596":"404","693":"apply-procurement","887":"procurement"}[chunkId] + "." + {"78":"cf426b45","490":"019b29a6","537":"1656218e","596":"c1c5e36b","693":"0bfa495c","887":"be19d37d"}[chunkId] + ".js";
};